import React from 'react';
import RightSideBar from '../../../components/Rightsidebar/RightSideBar';
import GenerateTemplate from '../../../components/GenerateTemplate/GenerateTemplate';

const ClientMail = ({
  applicantCodes,
  jobCode,
  tempApplicant,
  documents = null,
  onReceiveProps,
}) => {
  const onReceivePropsHandler = (pannel, load) => {
    onReceiveProps(pannel, load);
  };

  return (
    <div>
      <RightSideBar
        componentData={
          <GenerateTemplate
            isAssociatedProfile={true}
            tempApplicant={tempApplicant}
            documents={documents}
            applicantCodes={applicantCodes}
            jobCode={jobCode}
            onReceiveProps={onReceivePropsHandler}
            to={'clients'}
          />
        }
        componentLayout={clientMailObj}
        onReceiveProps={onReceivePropsHandler}
      />
    </div>
  );
};

export default ClientMail;

const clientMailObj = {
  title: 'Send E-mail to Client',
  description: '',
  bgImage: '',
};
